<template>
  <div>
    <b-modal size="xl" id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-exam-bank"
      @hidden="resetModal">
      <div class="container modal-create-exam-bank__body">
        <div class="action"><img class="btn-close custom-cursor btn-float-right" src="@/assets/img/x.png"
            @click="handleHideModal" /></div>
        <div class="header-modal">
          <h3>Ngân hàng đề thi</h3>
        </div>
        <div class="row margin-top-10">
          <div class="col-md-12 col-lg-4">
            <div class="item item__key input-custom-icon">
              <input v-model.lazy="paramQueryData.keyword" v-debounce="300" type="text"
                placeholder="Tìm kiếm đề theo tên"
                class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width" />
              <i class="icon-search font-size-16 primary-color"></i>
            </div>
            <div class="row margin-top-10">
              <div class="col-md-6">
                <b-form-select @change="handleChangeClassId" v-model="paramQueryData.classId" :options="listDataClass">
                  <option value="0">Lớp - Tất cả</option>
                </b-form-select>
              </div>
              <div class="col-md-6">
                <b-form-select @change="handleChangeSubjectId" v-model="paramQueryData.subjectId"
                  :options="listDataSubject">
                  <option value="0">Môn - Tất cả</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-8">
            <div class="display-flex justify-content-space-between">
              <div class="count-result">Tổng: {{ totalRecords }} kết quả</div>
            </div>
            <div class="wrap-right" ref="scrollContainer" @scroll="handleScrollExamBank">
              <div class="list-question">
                <div class="question-item display-flex" v-for="(item, index) of listDataExam" :key="index">
                  <div class="question col-md-8 align-items-center">
                    {{ item.name }}
                  </div>
                  <div class="col-md-4">
                    <div class="row p-10">
                      <a href="javascript:;"
                        @click="handleViewExam(item)"
                        class="item btn border-rd-20 font-size-16 display-flex-center item__add col-md-6">
                        Xem trước
                      </a>
                      <a href="javascript:;" @click="handleUsingExam(item)"
                        class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add col-md-6">
                        Sử dụng đề
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_action display-flex justity-content-space-around">
          <button type="button"
            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
            :disabled="isLoading" @click="handleHideModal">
            Hủy
          </button>
          <button type="button"
            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
            @click="handleShowConfimExamBank" :disabled="isLoading">
            Thêm mới
          </button>
        </div>
      </div>
    </b-modal>
    <ModalViewExam @closeModal="handleCloseModalViewExam" :lessonClassSchoolId="lessonClassSchoolId" v-if="isOpenModalViewExam" />
  </div>
</template>
<script>
import { getAllTypeFilter, getAllClassFilter } from "./../../../_api/";
import debounce from "@/directives/debounce";
import {
  getListBankExamExcercise,
  getListQuestionByExamId,
} from "./../../../_api/LessonClassSchoolServices";
import ModalViewExam from './../../../_components/ModalViewExam'

export default {
  directives: { debounce },
  components:{
    ModalViewExam
  },
  data() {
    return {
      isOpenModalViewExam:false,
      isLoading: false,
      paramQueryData: {
        keyword: "",
        pageIndex: 1,
        pageSize: 20,
        subjectId: 0,
        classId: 0,
      },
      listDataExam: [],
      totalRecords: 0,
      totalPage: 0,
      listDataSubject: [],
      listDataClass: [],
      listQuestionAdd: [],
      lessonClassSchoolId:''
    };
  },
  watch: {
    "paramQueryData.classId": "handleChangeClassId",
    "paramQueryData.keyword": "handleSearch",
    "paramQueryData.subjectId": "handleChangeSubjectId",
    "paramQueryData.pageIndex": "getDataExam",
  },
  mounted() {
    this.GetAllClass();
    this.getDataExam();
    this.handleShowModal();
  },
  methods: {
    handleCloseModalViewExam(){
      this.isOpenModalViewExam = false
    },
    handleViewExam(item){
      this.isOpenModalViewExam = true
      this.lessonClassSchoolId = item.id
    },
    handleUsingExam(item) {
      this.getListQuestionByExamId(item.id);
    },
    handleChangeSubjectId(e) {
      //this.subjectId = e.target.value
      this.handleOnFilter();
    },
    handleChangeClassId(e) {
      //this.classId = e.target.value
      this.handleOnFilter();
    },
    handleSearch(e) {
      //this.classId = e.target.value
      this.handleOnFilter();
    },
    getListQuestionByExamId(id) {
      getListQuestionByExamId(id).then((res) => {
        if (res && res.data && !res.errors) {
          this.listQuestionAdd = res.data;
          this.handleDone();
        }
      });
    },
    handleScrollExamBank() {
      const container = this.$refs.scrollContainer;
      const scrollHeight = container.scrollHeight;
      const scrollTop = container.scrollTop;
      const offsetHeight = container.offsetHeight;
      const bottomOffset = scrollHeight - (scrollTop + offsetHeight);
      if (bottomOffset <= 0 && !this.isLoading) {
        // Load more items when the user reaches the bottom with some offset
        let pageIndexSearch = this.paramQueryData.pageIndex + 1;
        if (pageIndexSearch <= this.totalPage) {
          this.paramQueryData.pageIndex++;
          this.getListQuestionBank();
        }
      }
    },
    handleShowConfimExamBank() { },
    resetData() {
      this.paramQueryData.pageIndex = 1;
      (this.listDataExam = []), (this.totalRecords = 0), (this.totalPage = 0);
    },
    handleOnFilter() {
      this.resetData();
      this.getDataExam();
    },
    getDataExam() {
      let self = this;
      getListBankExamExcercise(this.paramQueryData).then((res) => {
        if (res && res.data && !res.errors) {
          for (let i = 0; i < res.data.list.length; i++) {
            const item = res.data.list[i];
            self.listDataExam.push({ ...item });
          }

          self.totalRecords = res.data.paging.totalRecords;
          self.totalPage = res.data.paging.totalPage;
        }
      });
    },
    getTypesFilter() {
      let self = this;
      self.listDataSubject = [];
      this.subjectId = 0;
      getAllTypeFilter({ classId: this.paramQueryData.classId }).then((res) => {
        if (res && res.data && !res.errors) {
          for (let i = 0; i < res.data.ltsSubject.length; i++) {
            const item = res.data.ltsSubject[i];
            self.listDataSubject.push({
              value: item.subjectId,
              text: item.name,
            });
          }
        }
      });
    },
    GetAllClass() {
      let self = this;
      getAllClassFilter({}).then((res) => {
        if (res && res.data && !res.errors) {
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            self.listDataClass.push({ value: item.classId, text: item.name });
          }
        }
      });
    },
    handleDone() {
      this.handleHideModal();
      this.$emit("handleDone", this.listQuestionAdd);
    },
    resetModal() {
      console.log("resetModal");
      this.submitted = false;
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["modal-create-exam-bank"].toggle("#toggle-btn");
    },
    handleHideModal() {
      //this.$refs['modal-create-exam-bank'].hide()
      this.$emit("closeModal");
    },
    handleShowModal() {
      this.$refs["modal-create-exam-bank"].show();
    },
  },
};
</script>
<style lang="scss" scoped>
.p-10 {
  padding: 10px;
}

.modal-create-exam-bank__body {
  padding: 20px;
  background-color: white;
  border-radius: 15px;
  max-width: 90%;
  top: 2%;
  left: 5%;
  right: 0;
  position: fixed;
  z-index: 100000;
  margin: 0px;

  .modal__actions {
    .btn-delete {
      color: white;
      background: #fe0201;
      padding: 5px 20px 5px 20px;
      border-radius: 15px;
      font-family: sans-serif;
    }

    .btn-cancel {
      margin-right: 10px;
      font-family: sans-serif;
    }
  }
}

.wrap-right {
  padding: 5px;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  max-height: 45rem;
  overflow: auto;

  @media (max-height: 900px) {
    & {
      max-height: 41rem;
    }
  }

  @media (max-height: 820px) {
    & {
      max-height: 35rem;
    }
  }

  @media (max-height: 730px) {
    & {
      max-height: 30rem;
    }
  }

  @media (max-height: 650px) {
    & {
      max-height: 26rem;
    }
  }

  @media (max-height: 550px) {
    & {
      max-height: 20rem;
    }
  }
}

.question-item {
  overflow: auto;
  margin: 5px;
  border-radius: 15px;
  border: 1px solid #a1b5f3;
}

.margin-top-10 {
  margin-top: 10px;
}

.justify-content-space-between {
  justify-content: space-between;
}

.custom-line {
  width: 100%;
  display: flex;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;

  .line1 {
    width: 35%;
    height: 2px;
    background: #e5e5e5;
  }

  .line2 {
    width: 35%;
    height: 2px;
    background: #e5e5e5;
  }

  .text-line {
    margin-top: -10px;
    padding-left: 10px;
    padding-right: 10px;
    color: #e5e5e5;
  }
}

.display-flex-center {
  justify-content: center;
  align-items: center;
  text-align: center;
}

.align-items-center {
  align-items: center;
  display: flex;
}

.btn-float-right {
  float: right;
  width: 15px;
}
</style>
